import { AppHeader } from "components/app_header_v3/app_header";
import { DesktopLayout } from "components/layout/desktop_layout";
import { Footer } from "core/footer";

interface BookingDesktopLayoutProps {
  children: JSX.Element;
}

export function BookingDetailsDesktop({ children }: BookingDesktopLayoutProps) {
  return (
    <DesktopLayout header={<AppHeader />} body={children} footer={<Footer />} />
  );
}
